import { Adapter } from './adapter';
import { firstValueFrom } from 'rxjs';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- app-boundary-backlog
import { ArticleModel } from '../../../../app/models/articles';
import { Log } from '../../util/log';

/**
 * Liest Artikel aus dem lokalen Bestand.
 */
export class ArticleAdapter extends Adapter {
  /**
   * Lädt einen Artikel aus dem lokalen Bestand.
   *
   * @param id Artikel-ID
   * @returns Der Artikel oder `null`, wenn er fehlt oder nicht lesbar ist.
   */
  public async findLocal(id: number): Promise<ArticleModel | null> {
    try {
      const result = await firstValueFrom(
        this.services.articleService.find(id),
      );
      return result ?? null;
    } catch (error) {
      Log.error('ArticleAdapter.findLocal', error, { id });
      return null;
    }
  }
}